import { FETCH_ALL_VOLUNTEER_INTERESTS } from '../../constants/actionTypes'

export default (vlnVolunteerInterests = [], action) => {
    switch (action.type) {
        case FETCH_ALL_VOLUNTEER_INTERESTS:
            return action.payload;
        default:
            return vlnVolunteerInterests;
    }
}